import { render, staticRenderFns } from "./HomeOnboardingStatus.vue?vue&type=template&id=93687bf2"
import script from "./HomeOnboardingStatus.vue?vue&type=script&lang=js"
export * from "./HomeOnboardingStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports